const en = {
	产品: 'Products',
	关于我们: 'About Us',
	帮助中心: 'Help Center',
	信用基础: 'BUILT ON TRUST',
	加密支付: 'POWERED BY CRYPTO',
	全币种支持: 'Multi-Currency Support',
	全节点承兑: 'Full Node Acceptance',
	去中心担保: 'Decentralized Guarantee',
	立即开始使用: 'Get Started Now',
	闪电般的支付体验: 'Lightning-Fast Payment Experience',
	完成跨境支付: 'Complete Cross-Border Payments in 45 Seconds',
	多链支持: 'Multi-Chain Support',
	支持主流公链资产: 'Support for Major Public Chain Assets',
	实时结算: 'Real-Time Settlement',
	无需等待: 'No Waiting: Instant Transfers',
	超额担保: 'Over-Collateralization Guarantee',
	资金安全有保障: 'Funds Securely Guaranteed',
	一个钱包: 'One Wallet',
	所有可能: 'All Possibilities',
	商户收款: 'Merchant Payments',
	全球化支付网关: 'Global Payment Gateway',
	承兑服务: 'Acceptance Services',
	稳定可靠的承兑网络: 'Stable and Reliable Acceptance Network',
	数字资产: 'Digital Assets',
	多链资产管理: 'Multi-Chain Asset Management',
	下载: 'App Download',
	多节点承兑: 'Secure escrow payments',
	全币种支持: 'Send and spend',
	去中心担保: 'Bridge fiat with digital currencies',
	生态: 'NECO ECOSYSTEM',
	钱包: 'TEPAY Wallet',
	立即下载: 'Download Now',
	随时汇币: 'Send Crypto Payments Anytime',
	一个钱包: 'One Wallet',
	走天下: 'Travel the World',
	海量订单: 'Massive Orders',
	日进斗金: 'Earn Daily',
	首页描述: 'TePay is a decentralized credit payment infrastructure—not a bank. Financial services are facilitated by our network of acceptance nodes and blockchain‐based smart contracts. Collateral and credit mechanisms ensure secure, compliant transactions, while escrow and dispute resolution are managed via our DAO arbitration system. Multi-chain interoperability and integrated compliance modules provide a seamless, transparent payment experience for users and merchants alike.',
	轻松交易: 'CURRENCIES',
	slide2Text: 'Seamlessly exchange fiat and digital currencies through TePay’s decentralized multi-node network',
	slide2Info: 'TePay is a decentralized payment platform, not a traditional bank. Services are provided by our network of acceptance nodes and secured by blockchain smart contracts. Collateral and credit mechanisms ensure that every transaction is compliant and secure.',
	全球通用: 'EASILY',
	让每一笔支付: 'INSTANTLY',
	瞬间达成: 'MULTI-NODE',
	slide3Text: 'Seamlessly transact in any currency—fiat or crypto—through TePay’s robust network.',
	slide3Info: 'TePay is not confined to a single currency. Our decentralized platform empowers you to send, receive, and exchange multiple currencies effortlessly. Enjoy a unified experience where your money works for you across borders, secured by blockchain technology and dynamic credit mechanisms.',
	护航每笔交易: 'COLLATERAL',
	去中心化担保: 'DECENTRALIZED',
	安全无忧: 'SECURE PAYMENTS',
	slide4Text: 'Empower your transactions with decentralized collateral that secures trust and payment reliability.',
	slide4Info: 'TTePay is not a conventional bank—instead, our decentralized collateral system leverages over-collateralization, dynamic credit scoring, and DAO arbitration to secure every transaction. This robust guarantee mechanism bridges traditional finance and digital assets, ensuring that all payments are compliant, secure, and efficient.',
	一个钱包走天下: 'ONE WALLET',
	币随时付: 'CRYPTO ANYTIME',
	跨境无忧: 'NO BORDERS',
	slide5Text: 'Access all your assets from one secure wallet—fiat or crypto, manage them effortlessly.',
	slide5Info: 'TePay unifies your financial world by consolidating all payment instruments into a single wallet solution. Our integrated platform simplifies asset management and facilitates seamless global transactions, all underpinned by advanced blockchain technology and dynamic credit mechanisms.',
	海量订单: 'VAST ORDERS',
	日进斗金: 'DAILY WEALTH',
	slide6Text: 'Connect merchants’ and customers’ diverse currency needs—and earn.',
	slide6Info: 'TePay’s dynamic matching engine bridges the gap between fiat and digital currencies, empowering acceptance nodes to profit regardless of whether merchants or customers use fiat or crypto. Our platform ensures rapid settlements and maximizes revenue opportunities in every transaction.',
	边兑边赚: 'EARN & EXCHANGE',
	信用随行: 'CREDIT ON THE GO',
	slide7Text: 'Maximize profits with every exchange while your credit grows stronger.',
	slide7Info: 'TePay is not a traditional bank but ensures the security of transactions through a decentralized guarantee mechanism. Our system utilizes over-collateralization, dynamic credit scoring, and DAO arbitration to provide solid protection for every transaction. This powerful guarantee mechanism effectively connects traditional finance with digital assets, ensuring that all payments are compliant, secure, and efficient.',
	下载TEPAY: 'Download TEPAY APP',
	开启信用支付: 'TO GET STARTED',
	多币种支持: 'SUPPORT MULTIPLE',
	多节点承兑描述: 'ANYONE',
	下载Text: 'DOWNLOAD',
  "链上赋能": "On-chain Empowerment · Community E-commerce",
  "品牌即社区": "Brand as Community",
  "消费即投资": "Spending as Investment",
  "本地即全球": "Local as Global",
  "首页描述": "NECO (Laike) community e-commerce platform builds on Web3 decentralized trust framework, deeply integrating real consumption with transparent on-chain rebates to reshape value circulation among users, merchants, and communities - pioneering a new shared, trustworthy, and sustainable e-commerce paradigm.",
  "真实消费": "Real Consumption",
  "支撑返利": "Backed Rebates",
  "slide2Text": "More Purchases, More Authentic Rewards",
  "slide2Info": "NECO only generates corresponding bonds and points after order completion and on-chain confirmation. Rebates strictly match 20% merchant discounts with zero over-issuance. This means all platform rewards are paid by real cash flow, and every NECO/USAI transaction is traceable on blockchain explorers, completely eliminating 'ponzi scheme' risks.",
  "透明积分": "Transparent Points",
  "代币经济": "Tokenomics",
  "slide3Text": "On-chain Points, Verifiable Value",
  "slide3Info1": "Spending rebates are split into two ledgers: NECO platform token and USAI stablecoin.",
  "slide3Info2": "The former releases linearly at 0.2% daily, while the latter auto-balances exchange rates through burning/minting.",
  "slide3Info3": "All minting, burning, and release events are recorded by smart contracts. Anyone can check wallet balances, release countdowns, and transaction history in real-time, giving every incentive a public 'ID'.",
  "多角色": "Multi-Role",
  "激励生态": "Incentive Ecosystem",
  "slide4Text1": "Users, Leaders, Merchants - Win-Win Loop",
  "slide4Info1": "Users: Get 100% rebate points + NECO price appreciation & governance rights.",
  "slide4Info2": "Leaders: Earn commissions + extra NECO rewards for organizing group buys and managing communities.",
  "slide4Info3": "Merchants: Gain precise orders through discounts, enjoying zero-fee settlements and brand exposure.",
  "slide4Info4": "All earnings are encoded in the same on-chain formula with real-time reconciliation, creating a self-driven growth loop.",
  "合规保障": "Regulatory Compliance",
  "全程可审": "Fully Auditable",
  "slide5Text": "On-chain Traces, Regulation-Friendly",
  "slide5Info1": "TePay gateway handles KYC, fiat integration, and payment compliance. All transaction data, discount ratios, and point distributions are on-chain recorded.",
  "slide5Info2": "The platform also features dual oracles, price buffers, and a DAO risk fund. During extreme market conditions or policy changes, governance votes can trigger speed limits, buybacks, or pauses - ensuring regulatory confidence, user security, and ecosystem sustainability.",
  "合作伙伴": "Partners",
  "社区团购": "Community Group Buying",
  "社区小店": "Community Stores",
  "社区空间": "Community Spaces",
  "社区服务": "Community Services",
  "NECO优选": "NECO Premium",
  "暂未开放": "Coming Soon",
  "新闻标题": "News Center",
  "新闻1标题": "Announcement on Genesis Launch, APP Release, and Membership System Opening Time",
  "新闻1内容": "Dear community members:\n" +
    "\n" +
    "We plan to open the NECO/nUSDT and USAI/nUSDT trading pairs on Novai SWAP at 24:00 (GMT+8) on August 5th, completing the Genesis launch of the platform token and stablecoin.\n" +
    "\n" +
    "At the same time, the NECO APP will officially open for registration and launch the global membership system. You can perform the following operations in this system:\n" +
    "1. User registration and link sharing.\n" +
    "2. Deposit USDT into the pre-deposit account to convert it into USAI and purchase VIP membership.\n" +
    "3. Release of equivalent points for Genesis nodes and ordinary nodes (earning NECO rewards).\n" +
    "4. Receive member referrals and team point rewards, and manage your own team.\n" +
    "5. Release of consumption points (obtained from purchasing memberships, team rewards, and node rewards) as NECO.\n" +
    "6. Instant exchange of NECO into USAI and withdrawal (current version supports withdrawal as USDT).\n" +
    "7. Basic functions of consumption rebates (view NECO price, view SWAP NECO trading pairs, view announcements, etc.).\n" +
    "\n" +
    "If there are any time adjustments, we will announce them separately.",
  "返回": "Back",
  "消费返股": "Spend-to-Earn Community E-commerce",
  "全球首个": "Leading Web3.0",
  "WEB3社区电商平台": "Community E-commerce Platform",
  "消费": "Spend",
  "赚钱": "Earn",
  "持股": "Hold Shares",
  "合伙人": "Partner",
  "用户": "User",
  "股东": "Shareholder",
  "不只是电商": "Beyond traditional E-commerce",
  "更是社区电商": "Community-Driven Ecosystem",
  "共赢闭环": "Users, Leaders, Merchants",
  "用户描述": "User: 100% reward in $NECO, holding, growth, governance",
  "团长描述": "KOC: Group buying, earn commission, bonuses in $NECO",
  "商户描述": "Merchant: 0% order fee & global exposure, on-chain real-time settlement ",
  "三方描述": "All earnings are on-chain, ensuring transparent & self-sustaining growth",
  "购物聊天": "NECO AI: Shop by Chat",
  "边聊边选": "Chat & Choose",
  "聊天助手实时理解你的对话": "AI understands your needs in real-time,",
  "就能找到你要的东西": "finds what you want instantly",
  "AI优选": "AI-Picked",
  "的那一刻": "When you open NECO,",
  "已经在等你": "your perfect picks are ready",
  "时尚分身": "Style AI",
  "监控价格": "Tracks deals & prices,",
  "守护你的消费体验": "guards your shopping experience",
  "三类团购机制": "3 Group-Buy Modes",
  "附近团": "Local Groups",
  "熟人团": "Social Groups",
  "优选团": "Premium Groups",
  "全球战略布局": "Global Strategy",
  "使命与愿景": "NECO's Mission & Vision",
  "使命": "Mission",
  "愿景": "Vision",
  "使命描述": "Build a fair, transparent, participatory commerce system",
  "愿景描述": "Light up community economies worldwide",
  "公告": "Announcement",
  "铸造销毁协议": "Minting/Burning Protocol",
  "SWAP交易": "SWAP Trading",
  "NECO社区电商": "NECO Community E-Commerce",
  "菜单": "Menu",
  "安卓下载": "Android Download",
  "ios下载": "iOS Download",
  "NECO下载": "NECO APP Download",
  "支持版本": "Supports IOS Android Versions",
  "当前版本": "Current Version",
  "跨链桥": "Bridge",
  "合作伙伴关系": "PARTNERSHIP",
  "请加入社交媒体信息": " Please add social media information ",
  "联系我们": "Contact Us",
  "版权所有（公司）": " Copyright (Company)",
  "联系我们的邮件请填写": "Please fill in the email to contact us",
  "新闻": "News",
  "网页直连": "Web App",
  "铸造与销毁协议": "Mint & Burn",
  "更多": "More",
  "请通过": "Please approve",
  "与我们联系": "Contact Us",
  "版权所有": "All rights reserved",
  "联系": "Contact",
  "智能体": "Chatbot",

  
  "全球首个": "The world's first",
  "WEB3社区电商平台": "WEB3 community e-commerce platform",
  "消费": "Consumption",
  "持股": "Equity holding",
  "升值": "Appreciation",
  "重新定义消费的价值": "Redefining the value of consumption",
  "让消费成为财富的起点": "Make consumption the starting point of wealth",
  "消费即拥有，分享即收益": "Consume to own, share to earn",
  "NECO 是一套基于 Web3 技术的智能电商基础设施，通过「消费即持股」机制，让每一位用户在购物时获得真实权益与长期回报。 在这里，消费者不只是用户，更是平台的拥有者和生态的建设者。": "NECO is a smart e-commerce infrastructure based on Web3 technology. Through the \"consumption equals equity\" mechanism, every user can obtain real rights and long-term returns while shopping. Here, consumers are not just users, but also owners of the platform and builders of the ecosystem.",
  "核心技术": "Core Technology",
  "基于 Novai Chain 的二层网络": "Layer 2 network based on Novai Chain",
  "Neco Chain 是构建在 Novai Chain 之上的高性能二层网络，": "Neco Chain is a high-performance layer 2 network built on top of Novai Chain,",
  "专为高频电商与支付结算设计，平均出块时间仅 0.2 秒，TPS 超过 50,000。": "Designed specifically for high-frequency e-commerce and payment settlement, with an average block time of only 0.2 seconds and TPS exceeding 50,000.",
  "Neco Chain 将电商的每笔消费行为与激励记录上链，": "Neco Chain puts every e-commerce consumption behavior and incentive record on-chain,",
  "让商业行为具备长期可验证性与可追溯性。": "making business activities verifiable and traceable over the long term.",
  "高速并行账本结构": "High-speed parallel ledger structure",
  "智能结算与动态费用调节": "Smart settlement and dynamic fee adjustment",
  "消费凭证 NFT 化与积分资产化": "NFTization of consumption vouchers and tokenization of points",
  "核心特性": "Core Features",
  "链上结算": "On-chain Settlement",
  "每笔电商交易 0.2 秒确认，安全透明": "Each e-commerce transaction confirmed in 0.2 seconds, secure and transparent",
  "激励协议": "Incentive Protocol",
  "激励消费者、商家、渠道等为NECO做出贡献": "Incentivize consumers, merchants, channels, etc. to contribute to NECO",
  "权益积分": "Equity Points",
  "用户消费即持有可追踪、可变现的权益积分": "Users hold traceable and monetizable equity points through consumption",
  "共建共享": "Co-construction and Sharing",
  "首个去中心商业自治组织，共建共享NECO电商": "The first decentralized business autonomous organization, co-constructing and sharing the NECO e-commerce",
  "主要产品": "Main Products",
  "支持电商 RWA 的高性能公链": "High-performance public chain supporting e-commerce RWA",
  "稳定币、DEX、去中心信用等电商基础协议": "E-commerce basic protocols such as stablecoins, DEX, and decentralized credit",
  "同时为WEB2和WEB3用户服务的电商APP": "E-commerce APP serving both WEB2 and WEB3 users",
  "法币和数字货币统一支付及结算体系": "Unified payment and settlement system for fiat currency and digital currency",
  "竞争优势": "Competitive Advantages",
  "极速公链": "Ultra-fast Public Chain",
  "0.2 秒出块，支持百万级并发订单及支付交易。": "0.2 second block generation, supporting millions of concurrent orders and payment transactions.",
  "全球合规": "Global Compliance",
  "在全球各地通过 DAO 组织进行本地合规运营。": "Local compliance operations through DAO organizations around the world.",
  "电商 RWA": "E-commerce RWA",
  "第一个将现实世界电商完全放在链上运行的平台。": "The first platform to fully run real-world e-commerce on-chain.",
  "商业闭环": "Business Closed Loop",
  "让消费、社交与收益形成价值闭环。": "Form a value closed loop among consumption, social interaction, and earnings.",
  "全球分销体系让每个用户都能成为品牌的传播者与收益方。": "The global distribution system allows every user to become a brand promoter and beneficiary.",
  "消费者端": "Consumer End",
  "注册/消费即得积分奖励，积分每日释放为资产。": "Register/consume to get point rewards, points released daily as assets.",
  "商家端": "Merchant End",
  "一键接入结算 API，设置折让比例与积分政策。": "One-click access to settlement API, set discount ratio and point policy.",
  "分销端": "Distribution End",
  "允许全球用户参与分销，共享收益与品牌成长。": "Allow global users to participate in distribution, sharing revenue and brand growth.",
  "NECO 生态系统": "NECO Ecosystem",
  "一个融合金融、科技与商业的去中心化生态。": "A decentralized ecosystem integrating finance, technology, and commerce.",
  "Neco Chain 公链": "Neco Chain Public Chain",
  "商业级高速 Layer 2 网络（Novai L2），提供结算与数据验证基础设施。": "Commercial-grade high-speed Layer 2 network (Novai L2), providing settlement and data verification infrastructure.",
  "NECO App": "NECO App",
  "用户购物、签到、邀请与分销的统一入口。": "Unified entry point for user shopping, check-in, invitation, and distribution.",
  "USAI 稳定币": "USAI Stablecoin",
  "用于平台内支付与结算的稳定币资产，锚定美元价值。": "Stablecoin asset used for payment and settlement within the platform, pegged to US dollar value.",
  "U Card 全球消费卡": "U Card Global Consumption Card",
  "连接线上线下消费场景，支持积分抵扣与现金返还。": "Connects online and offline consumption scenarios, supports point deduction and cashback.",
  "NECO AI 智能系统": "NECO AI Intelligent System",
  "通过 AI 分析用户行为，实现个性化推荐与安全风控。": "Analyze user behavior through AI to achieve personalized recommendations and security risk control.",
  "消费金融该协议": "Consumer Finance Protocol",
  "提供通用的去中心化金融基础设施，支持电商资产流通。": "Provide universal decentralized financial infrastructure to support e-commerce asset circulation.",
  "稳定币生态": "Stablecoin Ecosystem",
  "构建覆盖支付、结算与跨境流通的稳定币网络。": "Build a stablecoin network covering payments, settlements, and cross-border circulation.",
  "团队及投资人": "Team and Investors",
  "全球化视野 · 多元化背景。": "Global vision · Diversified background.",
  "NECO 团队成员来自新加坡、中国、阿联酋等地，拥有电商、金融科技与区块链技术领域超过十年的行业经验。": "NECO team members come from Singapore, China, UAE and other regions, with over ten years of industry experience in e-commerce, fintech and blockchain technology.",
  "投资人": "Investors",
  "运营团队": "Operations Team",
  "Moe Farmani": "Moe Farmani",
  "拥有多年欧洲、中东、南美零售企业创业经验,曾创建迪拜领先的数字货币交易所 加密货币的重度信仰者": "Has years of entrepreneurial experience in European, Middle Eastern, and South American retail enterprises. Founded a leading cryptocurrency exchange in Dubai. A strong believer in cryptocurrencies",
  "Matt Romman": "Matt Romman",
  "从事迪拜房地产和零售行业多年。拥有丰富的跨国公司管理经验。": "Worked in Dubai real estate and retail industries for many years. Has rich multinational management experience.",
  "Alex Eric": "Alex Eric",
  "曾任职OKX，负责公司品牌和战略": "Previously worked at OKX, responsible for company branding and strategy",
  "Manoharlal": "Manoharlal",
  "Novai Chain Founder， 全面支撑NECO技术落地。": "Novai Chain Founder, fully supporting NECO technology implementation.",
  "官方路线图": "Official Roadmap",
  "2025 — 创世与启动": "2025 — Genesis and Launch",
  "2025 — 增长与市场拓展": "2025 — Growth and Market Expansion",
  "2026 — 生态深化与 AI 赋能": "2026 — Ecosystem Deepening and AI Empowerment",
  "上半年（Q2–Q3）": "First Half (Q2-Q3)",
  "完成白皮书、制度模型与产品原型开发": "Complete whitepaper, institutional model and product prototype development",
  "组织九大社区进行创世启动": "Organize nine communities for genesis launch",
  "完成 300 个节点招募，发行 NECO & USAI 代币，添加初始流动性池": "Complete recruitment of 300 nodes, issue NECO & USAI tokens, add initial liquidity pool",
  "发布 NECO APP BETA 测试版": "Release NECO APP BETA test version",
  "下半年（Q3–Q4）": "Second Half (Q3-Q4)",
  "全球社区运营中心部署完成": "Global community operation center deployment completed",
  "NECO 优选店铺与创世商户上线": "NECO preferred stores and genesis merchants go live",
  "推动注册用户突破 10 万": "Drive registered users to exceed 100,000",
  "启动空投及全球电商启动大会": "Launch airdrop and global e-commerce launch conference",
  "Q4：好货推广 & 本地电商": "Q4: Good Products Promotion & Local E-commerce",
  "上线「好货系统」并开放会员商家入驻": "Launch \"Good Products System\" and open membership merchant registration",
  "在主要国家开通 TePay 法币支付": "Enable TePay fiat payment in major countries",
  "完成中国、韩国、越南 10 家 NECO Best 本地电商落地": "Complete landing of 10 NECO Best local e-commerce in China, Korea, and Vietnam",
  "海外注册用户突破 50 万，VIP 用户突破 5 万": "Overseas registered users exceed 500,000, VIP users exceed 50,000",
  "举办第二次社区电商大会，开放跨境卖家注册": "Host second community e-commerce conference, open cross-border seller registration",
  "拓展中东、南美、非洲与欧洲本地市场，整合供应链": "Expand local markets in Middle East, Latin America, Africa and Europe, integrate supply chain",
  "注册用户突破 100 万，VIP 用户突破 10 万": "Registered users exceed 1 million, VIP users exceed 100,000",
  "Q1–Q2：体系完善": "Q1-Q2: System Improvement",
  "跨境卖家突破 10 万，商家数量超 10 万": "Cross-border sellers exceed 100,000, merchant count exceeds 100,000",
  "举办第一届 NECO 电商生态大会": "Host first NECO e-commerce ecosystem conference",
  "上线稳定币生态与信用体系": "Launch stablecoin ecosystem and credit system",
  "注册用户突破 500 万，VIP 超过 20 万": "Registered users exceed 5 million, VIP exceed 200,000",
  "Q3–Q4：智能升级": "Q3-Q4: Intelligent Upgrade",
  "获得主要国家支付牌照，全面上线法币支付服务": "Obtain payment licenses in major countries, fully launch fiat payment services",
  "上线 AI 选品与推荐功能": "Launch AI product selection and recommendation features",
  "商家信用、积分全面上链": "Merchant credit and points fully put on-chain",
  "NECO Best 优选商家突破 100 家": "NECO Best preferred merchants exceed 100",
  "注册用户突破 1000 万，VIP 超过 50 万": "Registered users exceed 10 million, VIP exceed 500,000",
  "加入 NECO": "Join NECO",
  "消费创造财富，社区共建共享。": "Consumption creates wealth, community co-builds and shares.",
  "一分钟带你了解NECO": "Here's a One-Minute Introduction to NECO",
  "NECO 通过链上透明的返利机制，让每一次消费都能获得真实收益。": "NECO enables genuine returns on every transaction through its transparent on-chain rebate mechanism.",
  "相比传统电商，NECO 的利润由智能合约按比例即时返还，0 抽佣、0 压货。": "Compared to traditional e-commerce, NECO's profits are instantly and proportionally refunded by smart contracts, with 0 commissions and 0 inventory pressure.",
  "用户与商家共享增长红利。": "Users and merchants share the growth dividends.",
  "全球版": "Global Version",
  "中国版": "Chinese Version",

}
export default en



// WEBPACK FOOTER //
// ./src/i18n/config/en.js